export default __webpack_public_path__ + "static/media/telephone-box.eabfa3e5.svg";